export const MODAL_EDIT_SHOW = "MODAL_EDIT_SHOW";
export const MODAL_EDIT_HIDE = "MODAL_EDIT_HIDE";

const initialState = {
  showModal: false
};

export default function modalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MODAL_EDIT_SHOW:
      return payload;

    case MODAL_EDIT_HIDE:
      return payload;

    default:
      return state;
  }
}

export function showAssignModal() {
  return {
    type: MODAL_EDIT_SHOW,
    payload: {
      showModal: true
    }
  };
}

export function hideAssignModal() {
  return {
    type: MODAL_EDIT_HIDE,
    payload: {
      showModal: false
    }
  };
}
